import React, { Component } from 'react';

import UserModel from './UserModel';

import { Table, Popconfirm } from 'antd';

class ParkeonParkinglocationTable extends Component {

  state = {
    children: []
  }

  columns = [{
    title: 'Lokalita',
    dataIndex: 'ParkingLocationName',
    key: 'ParkingLocationName',    
  }, {
    title: 'Identifikátor projektu',
    dataIndex: 'ParkID',
    key: 'ParkID',
    width: '25%',    
  }, {
    title: 'Identifikátor terminálu',
    dataIndex: 'TerminalID',
    key: 'TerminalID',
    width: '25%',    
  }, {
    title: 'Akce',
    key: 'Action',
    width: 100,
    render: (text, record) => (        
      UserModel.isInRoles(['ADMIN', 'PARKEON_PARKINGLOCATIONS_WRITE']) 
        ? <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
              this.props.onRemoveRow(record.id)
            }} okText="Ano" cancelText="Ne">
            <a onClick={(e) => { e.preventDefault(); }}>Smazat</a>      
          </Popconfirm>
        : null
    ),
  }]

  render() {    
    return (    
      <Table         
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={this.columns} 
        dataSource={this.props.data} 
        style={{border: '0px'}} />
    );
  }
}

export default ParkeonParkinglocationTable;


// WEBPACK FOOTER //
// ./src/components/ParkeonParkinglocationTable.js